<template>
  <focus-trap>
    <div
      tabindex="-1"
      class="modal d-block _confirm_password_modal _confirm-password-modal"
      @click.self="close"
      @keyup.esc="close"
    >
      <div class="modal-dialog modal-dialog-centered modal-557px">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">
              Confirm Password
            </h5>
          </div>

          <div class="modal-body">
            <div class="small text-muted">
              Please confirm your password before continuing.
            </div>
            <form
              class="mt-3"
              @submit.prevent="confirmPassword"
            >
              <div class="form-group">
                <label for="confirm_password">Password</label>
                <FormPassword
                  v-model="form.password"
                  :input-id="'confirm_password'"
                  :input-class="'_password'"
                  :input-placeholder="'Enter your current password'"
                  :validation-message="form.errors.get('password')"
                  :validation-test-id="'confirm_password_error_msg'"
                />
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-teal _submit _confirm-password-submit"
              :disabled="form.busy"
              @click="confirmPassword"
            >
              <span v-if="form.busy">
                <i class="fa fa-btn fa-spinner fa-spin" /> Confirming
              </span>
              <span v-else>Confirm Password</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </focus-trap>
</template>

<script>
import FormPassword from "@Forms/FormPassword.vue";

export default {
  name: "ConfirmPassword",

  components: { FormPassword },

  data: () => ({
    form: new SparkForm({
      password: "",
    }),
    confirmed: false,
  }),

  watch: {
    $route() {
      this.close();
    },
  },

  created() {
    this.updateLocalStorage();
  },

  methods: {
    close() {
      if (!this.form.busy) {
        this.updateLocalStorage();
        this.$emit("close");
      }
    },

    confirmPassword() {
      const url = this.$apiUrl("password/confirm");

      Spark.post(url, this.form).then(
        () => {
          this.confirmed = true;
          this.close();
        },
        () => {},
      );
    },

    updateLocalStorage() {
      localStorage.setItem(
        "passwordConfirmed",
        this.confirmed ? "true" : "false",
      );
    },
  },
};
</script>
